import React, { useEffect, useState } from 'react'
import Card from '../components/Card'
import FormField from '../components/FormField'
import Loader from '../components/Loader'
import { toast } from 'react-hot-toast'

const RenderCards = ({ data, title }) => {
  if (data?.length > 0) {
    return (
      data.map((post) => <Card key={post._id} {...post} />)
    );
  }

  return (
    <h2 className="mt-5 font-bold text-[#6469ff] text-xl uppercase">{title}</h2>
  );
};

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [allPosts, setAllPosts] = useState(null);

  const [searchText, setSearchText] = useState('');
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [searchedResults, setSearchedResults] = useState(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL
  const POST_DATA_API = BASE_URL + "/post"

  const fetchPosts = async () => {
    setLoading(true)

    try {
      
      //The fetch function in JavaScript returns a Promise that resolves to the Response object representing the response to the request. 
      const response = await fetch(POST_DATA_API, { 
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      console.log("response is", response)
      if (response.ok) {
        const result = await response.json();
        console.log("result is", result)
        setAllPosts(result.data.reverse());
      }

    } catch (error) {
      toast.error("Error while getting posts")
    }
    finally{
      setLoading(false)
    }
  }

  const handleSearchChange = (e) => {
    clearTimeout(searchTimeout);
    setSearchText(e.target.value);

    setSearchTimeout(
      setTimeout(() => {
        const searchResult = allPosts.filter((item) => 
        item.name.toLowerCase().includes(searchText.toLowerCase()) || 
        item.prompt.toLowerCase().includes(searchText.toLowerCase()) || 
        item.model.toLowerCase().includes(searchText.toLowerCase()));
        setSearchedResults(searchResult);
      }, 500),
    );
  };

  useEffect(() => {
    fetchPosts()
  }, [])
  
  return (
    <section className="max-w-7xl mx-auto mt-2">
      <div>
        <h1 className="font-extrabold text-[#222328] text-5xl">The <span className='orange_gradient'>Community</span> Showcase</h1>
        <p className="mt-2 text-[#666e75] text-xl max-w-[600px]">Browse through a collection of imaginative and visually stunning images generated by AI models</p>
      </div>

      <div className="mt-8">
        <FormField
          labelName="Search posts"
          type="text"
          name="text"
          placeholder="Search something..."
          value={searchText}
          handleChange={handleSearchChange}
        />
      </div>

      <div className="mt-10">
        {loading ? (
          <div className="flex justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            {searchText && (
              <h2 className="font-medium text-[#666e75] text-xl mb-3">
                Showing Resuls for <span className="text-[#222328]">{searchText}</span>:
              </h2>
            )}
            <div className="grid lg:grid-cols-4 sm:grid-cols-3 xs:grid-cols-2 grid-cols-1 gap-3">
              {searchText ? (
                <RenderCards
                  data={searchedResults}
                  title="No Search Results Found"
                />
              ) : (
                <RenderCards
                  data={allPosts}
                  title="No Posts Yet"
                />
              )}
            </div>
          </>
        )}
      </div>
    </section>
  )
}

export default Home